import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

document.addEventListener( 'DOMContentLoaded', function () {
  const section = document.querySelector( '.e-stn--focus-scroll-line-animations' );
  if ( !section ) return;

  const getSVG = ( svgObject ) => svgObject?.contentDocument?.querySelector( 'svg' ) || null;

  function animatePaths( svg ) {
    const paths = svg.querySelectorAll( 'path, line, circle, rect, ellipse, polygon, polyline' );
    paths.forEach( ( path, index ) => {
      gsap.fromTo(
        path,
        { opacity: 0, scale: 0.8 },
        { opacity: 1, scale: 1, duration: 0.8, delay: index * 0.1, ease: 'power2.out' }
      );
    } );
  }

  function triggerSVGAnimation( svgObject ) {
    const svg = getSVG( svgObject );
    if ( !svg ) return;

    if ( svg.svgatorPlayer ) {
      svg.svgatorPlayer.play();
    } else {
      animatePaths( svg );
    }
  }

  function setupScrollTrigger( container, svgObject ) {
    const runAnimation = () => setTimeout( () => triggerSVGAnimation( svgObject ), 200 );

    ScrollTrigger.create( {
      trigger: container,
      start: 'top 70%',
      end: 'bottom 20%',
      once: true,
      onEnter: runAnimation,
      onEnterBack: runAnimation,
    } );
  }

  function initContainer( container ) {
    const svgObject = container.querySelector( 'object' );
    if ( !svgObject ) return;

    const setup = () => setupScrollTrigger( container, svgObject );

    svgObject.contentDocument ? setup() : svgObject.addEventListener( 'load', setup );
    setTimeout( setup, 1000 ); // fallback
  }

  function setupHoverEffects( svgObject ) {
    const svg = getSVG( svgObject );
    if ( !svg ) return;

    svg.querySelectorAll( 'path, line, circle, rect, ellipse, polygon, polyline' ).forEach( ( path ) => {
      path.addEventListener( 'mouseenter', () =>
        gsap.to( path, { strokeWidth: 6, duration: 0.3, ease: 'power2.out' } )
      );
      path.addEventListener( 'mouseleave', () =>
        gsap.to( path, { strokeWidth: 4, duration: 0.3, ease: 'power2.out' } )
      );
    } );
  }

  // 🔹 Init scroll animations
  section.querySelectorAll( '.e-svg' ).forEach( initContainer );

  // 🔹 Init hover effects
  section.querySelectorAll( '.e-svg object' ).forEach( ( svgObject ) => {
    const initHover = () => setupHoverEffects( svgObject );
    svgObject.contentDocument ? initHover() : svgObject.addEventListener( 'load', initHover );
  } );

  // Refresh after a delay
  setTimeout( () => ScrollTrigger.refresh(), 2000 );
} );

// ✅ Fallback for already-loaded DOM
if ( document.readyState !== 'loading' ) {
  document.dispatchEvent( new Event( 'DOMContentLoaded' ) );
}
